module.exports = {
  initial: 'initial',
  unavailable: 'unavailable',
  unfetched: 'unfetched',
  fetching: 'fetching',
  fetched: 'fetched',
  errored: 'errored'
};
